import { useParams, Link } from "react-router-dom";
import SEO from "../components/SEO";
import CTAStrip from "../components/CTAStrip";
import { LOCAL_PAGES } from "../data/local";
import { COMPANY, IMG } from "../data/site";

export default function LocalPage() {
    const params = useParams();
    // routes are registered explicitly; pick slug from path
    const slug = (params.slug || window.location.pathname.replace(/^\//, "")).split("/")[0];
    const page = LOCAL_PAGES[slug];
    if (!page) {
        return (
            <section className="max-w-[1400px] mx-auto px-6 py-32 text-center">
                <h1 className="font-display text-4xl text-white">Page non trouvée</h1>
                <Link to="/" className="btn-ghost mt-6 inline-flex">Retour à l'accueil</Link>
            </section>
        );
    }

    return (
        <>
            <SEO
                title={page.seoTitle}
                description={page.seoDescription}
                keywords={[`portail ${page.city}`, `clôture ${page.city}`, `brise-vue ${page.city}`, "Portail du Léman"]}
            />

            <section className="relative">
                <div className="absolute inset-0" aria-hidden>
                    <img src={IMG.entrance} alt="" className="w-full h-full object-cover opacity-20" />
                    <div className="absolute inset-0 bg-gradient-to-b from-[#0A1118]/85 to-[#0A1118]" />
                </div>
                <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-16">
                    <div className="divider-tag mb-6">Zone — {page.city}</div>
                    <h1 className="font-display text-4xl md:text-6xl text-white leading-[1.05] tracking-tight max-w-4xl">{page.h1}</h1>
                    <p className="mt-7 text-white/70 max-w-3xl text-lg leading-relaxed">{page.intro}</p>
                </div>
            </section>

            <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-12 gap-12">
                <div className="md:col-span-7">
                    <div className="divider-tag mb-5">Nos services à {page.city}</div>
                    <ul className="grid sm:grid-cols-2 gap-px bg-white/[0.07] border border-white/[0.07]">
                        {page.services.map((s) => (
                            <li key={s} className="bg-[#0B141C] px-6 py-5 text-white/80 text-sm">{s}</li>
                        ))}
                    </ul>

                    <div className="mt-12 prose-invert max-w-none text-white/65 leading-relaxed space-y-4">
                        <p>
                            Nos équipes interviennent régulièrement à {page.city} et ses alentours. Chaque projet débute par une visite technique gratuite, permettant d'évaluer le terrain, les contraintes (pente, vent, sol) et de définir précisément la solution la plus adaptée.
                        </p>
                        <p>
                            Nos installations à {page.city} sont conçues pour durer : aluminium thermolaqué, motorisations silencieuses, finitions haut de gamme. Le tout depuis nos ateliers du Pays de Gex.
                        </p>
                    </div>
                </div>

                <aside className="md:col-span-5">
                    <div className="border border-white/10 bg-[#0E1721] p-7">
                        <div className="text-[10px] tracking-[0.28em] uppercase text-brand-accent/80 mb-4">Contact direct</div>
                        <div className="font-display text-2xl text-white mb-5">Devis pour {page.city}</div>
                        {COMPANY.phones.map((p) => (
                            <a key={p.tel} href={`tel:${p.tel}`} className="block py-3 border-b border-white/[0.06] last:border-0">
                                <div className="text-[10px] uppercase tracking-widest text-white/40">{p.label}</div>
                                <div className="text-white">{p.value}</div>
                            </a>
                        ))}
                        <Link to="/contact" className="btn-primary w-full mt-6">Demander un devis</Link>
                    </div>
                </aside>
            </section>

            <CTAStrip title={`Un projet à ${page.city} ?`} subtitle="Visite technique gratuite, conseil personnalisé et devis détaillé." />
        </>
    );
}
